<script setup>
import { usePublicTheme } from '@/composables/usePublicTheme'

defineProps({
  title: String,
  congregacion: String,
  userName: String,
})
defineEmits(['click-user', 'cambiar-vista'])

const themeStore = usePublicTheme()
</script>

<template>
  <div class="salida-header">
    <span class="header-title">{{ title || congregacion || 'Salida de Predicación' }}</span>

    <div class="header-actions">
      <!-- <button
        class="header-icon-btn"
        title="Ver en modo fácil (para mayores)"
        @click="$emit('cambiar-vista')"
      >
        <i class="pi pi-users" />
      </button> -->

      <button
        class="header-icon-btn"
        :title="themeStore.theme === 'dark' ? 'Modo claro' : 'Modo oscuro'"
        @click="themeStore.toggle()"
      >
        <i :class="themeStore.theme === 'dark' ? 'pi pi-sun' : 'pi pi-moon'" />
      </button>

      <!-- <button
        class="user-avatar-btn"
        :title="userName || 'Ingresar tu nombre'"
        @click="$emit('click-user')"
      >
        <span v-if="userName">{{ userName.charAt(0).toUpperCase() }}</span>
        <i v-else class="pi pi-user" />
      </button> -->
    </div>
  </div>
</template>

<style scoped>
.salida-header {
  background: rgba(0, 122, 255, 0.95);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  padding: 0 16px;
  padding-top: max(env(safe-area-inset-top, 0px), 12px);
  padding-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-title {
  color: #fff;
  font-size: 19px;
  font-weight: 600;
  letter-spacing: -0.3px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 10px;
}

.header-icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.75);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.header-icon-btn::after {
  content: '';
  position: absolute;
  inset: -5px;
}

.header-icon-btn:active {
  background: rgba(255, 255, 255, 0.35);
}

.user-avatar-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s;
}

.user-avatar-btn::after {
  content: '';
  position: absolute;
  inset: -5px;
}

.user-avatar-btn:active {
  background: rgba(255, 255, 255, 0.4);
}
</style>
